export var ConditionKind;
(function (ConditionKind) {
    ConditionKind["Unknown"] = "Unknown";
    ConditionKind["UrlMatch"] = "UrlMatch";
    ConditionKind["UrlNotMatch"] = "UrlNotMatch";
    ConditionKind["ShowFromDate"] = "ShowFromDate";
    ConditionKind["ShowUntilDate"] = "ShowUntilDate";
})(ConditionKind || (ConditionKind = {}));
